import { Container, Typography } from '@cleartrip/ct-design-components'
import { motion } from 'framer-motion'
import { memo } from 'react'

import ChevronDown from '@/assets/svg/ChevronDown'

import { TUPLE_COLORS } from '../config/tupleTheme'

export type TupleGroupFooterVariant = 'expand' | 'collapse'

export interface TupleGroupFooterProps {
  label: string
  onClick: () => void
  /** expand = collapsed nudge (+N more); collapse = hide options. */
  variant: TupleGroupFooterVariant
}

const TupleGroupFooter: React.FC<TupleGroupFooterProps> = ({ label, onClick, variant }) => {
  const isExpand = variant === 'expand'

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <Container
      aria-expanded={!isExpand}
      aria-label={isExpand ? label : undefined}
      className={`${isExpand ? 'br-b-16 py-2' : 'br-12 mt-3'} flex flex-center flex-middle c-pointer w-100p`}
      role='button'
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <Typography color='heading' variant='L3'>
        {label}
      </Typography>
      <motion.div
        animate={{ rotate: isExpand ? 0 : 180 }}
        className='ml-1 flex flex-middle'
        style={{ height: 16, width: 24 }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        <ChevronDown color={TUPLE_COLORS.heading} strokeWidth='1.5' />
      </motion.div>
    </Container>
  )
}

export default memo(TupleGroupFooter)
